export const defaultDeserializer = JSON.parse;
//# sourceMappingURL=utils.js.map